import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { EprCodeProcessService } from "../../../../../services/eprcode-process/eprcode-process.service";

interface IVariable {
  id: string;
  body: any;
}

export const useUpdateEPR = () => {
  const queryClient = useQueryClient();
  const { mutate, ...restMutation } = useMutation({
    mutationFn: ({ id, body }: IVariable) => EprCodeProcessService.updateEPRCodeRequest(id, body),
  });

  const updateEPRRequest = (
    vars: IVariable,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["epr-code-requests"],
        });
        notification.success({
          message: "Thành công!",
          description: options?.successText ?? `Duyệt yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Duyệt yêu cầu thất bại.`,
        });
      },
    });
  };
  return { mutate, updateEPRRequest, ...restMutation };
};
